export default __webpack_public_path__ + "static/media/Investment_Banner.5ad169d8.svg";